<template>
    <div class="team-standings">
        <team-matches-overview :matches="filteredTeamMatches" @show-all="$emit('show-all-matches')" />

        <div class="team-section-title">
            <span class="team-section-title__bar custom-orange" />
            {{ isBracket ? (type === 'cup' ? 'Κύπελλο' : 'Playoffs') : 'Βαθμολογία' }}
        </div>

        <standings-table
            v-if="!isBracket"
            :ranking="ranking || []"
            :highlight-team-id="teamId"
        />
        <!-- the bracket made in the CMS; the playoffs of a league without one: the picture of its standings -->
        <bracket-board v-else-if="bracketLoaded" :bracket="bracket" @match="openMatch" />
    </div>
</template>

<script>
    import TeamMatchesOverview from '@/components/TeamMatchesOverview'
    import BracketBoard from '@/components/BracketBoard'
    import bracketService from '@/services/bracket'
    import StandingsTable from '@/components/StandingsTable'

    // Filters a match list down to the phase the team page shows
    function filterByType(matches, type) {
        const safeMatches = Array.isArray(matches) ? matches : []
        if (type === 'cup') {
            return safeMatches.filter(match => Boolean(match?.cup))
        }
        if (type === 'playoffs') {
            return safeMatches.filter(match => !match?.cup && match?.phase === 'playoffs')
        }
        if (type === 'regular_season' || type === 'placements') {
            return safeMatches.filter(match => !match?.cup && match?.phase === type)
        }
        return safeMatches
    }

    export default {
        components: { TeamMatchesOverview, BracketBoard, StandingsTable },
        props: {
            type: {
                type: String,
                default: null
            },
            ranking: {
                type: Array,
                default: null
            },
            matches: {
                type: Array,
                default: null
            },
            teamMatches: {
                type: Array,
                default: null
            },
            teamId: {
                type: [Number, String],
                default: null
            },
            seasonId: {
                type: [Number, String],
                default: null
            },
            leagueId: {
                type: [Number, String],
                default: null
            }
        },
        data() {
            return {
                bracket: null,
                bracketLoaded: false,
                bracketRequest: null
            }
        },
        computed: {
            isBracket() {
                return this.type === 'cup' || this.type === 'playoffs'
            },
            bracketScope() {
                if (!this.isBracket || !this.seasonId || (this.type === 'playoffs' && !this.leagueId)) return null
                return this.type === 'cup'
                    ? { seasonId: this.seasonId, cup: true }
                    : { seasonId: this.seasonId, leagueId: this.leagueId }
            },
            filteredTeamMatches() {
                return filterByType(Array.isArray(this.teamMatches) ? this.teamMatches : this.matches, this.type)
            }
        },
        watch: {
            bracketScope: {
                handler() {
                    this.fetchBracket()
                },
                immediate: true
            }
        },
        methods: {
            fetchBracket() {
                this.bracket = null
                this.bracketLoaded = false
                const scope = this.bracketScope
                const requestKey = JSON.stringify(scope)
                this.bracketRequest = requestKey
                if (!scope) {
                    this.bracketLoaded = true
                    return
                }
                bracketService.getBracket(scope).then(resp => {
                    // only the answer of the latest choice
                    if (this.bracketRequest === requestKey) {
                        this.bracket = resp.data || null
                    }
                }).catch(() => {}).finally(() => {
                    if (this.bracketRequest === requestKey) {
                        this.bracketLoaded = true
                    }
                })
            },
            openMatch(matchId) {
                this.$router.push(`/Match/${matchId}`)
            }
        }
    }
</script>

<style scoped>
.team-section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 20px 0 12px;
    padding: 8px 14px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: Ubuntu, Arial, sans-serif;
    font-size: 1.1rem;
    font-weight: 800;
}

.team-section-title__bar {
    width: 5px;
    height: 20px;
    border-radius: 2px;
}
</style>
